import type { ControlProps } from './types';

/** Generic fallback control for option types without a dedicated widget. */
export function TextControl({ schema, value, disabled, onChange }: ControlProps) {
  return (
    <input
      type="text"
      aria-label={schema.label}
      value={value === undefined || value === null ? '' : String(value)}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
